import { Routes, Route } from "react-router";
import './App.css';
import Dashboard from "./pages/dashboard";

function App() {
  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<Dashboard/>} />
      </Routes>
    </div>
  );
}

export default App;
